import React from 'react';
import Hero from '../components/home/Hero';
import Specialties from '../components/home/Specialties';
import Services from '../components/home/Services';
import About from '../components/home/About';
import Projects from '../components/home/Projects';
import Contact from '../components/home/Contact';
import useMeta from '../hooks/useMeta';

const HomePage = () => {
  useMeta(
    'SL Flise- og murerforretning | Flisearbejde & Murerarbejde i Tønder',
    'Søger du en professionel murer eller flisemurer i Tønder? SL Flise- og murerforretning har 25 års erfaring med flisearbejde, klinker, badeværelser og renovering.'
  );

  return (
    <>
      <Hero />
      <Specialties />
      <Services />
      <About />
      <Projects />
      <Contact />
    </>
  );
};

export default HomePage;
